<template>
    <b-col
        cols="12"
        md="4"
        xl="3"
        class="bg-white sidebar vh-md-100 p-0">
        <div class="sidebar-nav-menu">
            <div class="search">
                <input
                    v-model="search"
                    type="text"
                    placeholder="Buscar">
            </div>
            <b-navbar-toggle
                class="d-flex d-md-none"
                target="sidebar-collapse">
                <span class="btn-bar" />
            </b-navbar-toggle>
        </div>
        <div
            v-if="(isValidity != false)"
            v-show="visibility"
            class="box-time-left">
            <div class="header-time-left">
                <p class="title-time-left">
                    Acesso ao curso
                </p>
                <button
                    class="close-time-left"
                    @click="visibility = false">
                    x
                </button>
            </div>
            <p class="time-left">
                Seu acesso as aulas do curso expira em {{ isValidity }}.
            </p>
        </div>
        <div
            v-if="search && !filteredModules.length"
            class="d-flex flex-column py-4 px-2 align-items-center">
            <i class="icon-info text-primary fs25" />
            <p class="font-weight-bold">
                Sem resultados para sua pesquisa
            </p>
        </div>
        <b-navbar
            v-show="filteredModules.length"
            toggleable="md"
            class="px-0">
            <b-collapse
                id="sidebar-collapse"
                is-nav>
                <div class="modules-area">
                    <div
                        v-for="(theModule, idx) in filteredModules"
                        :key="idx">
                        <div
                            v-b-toggle="`collapse-${idx}`"
                            class="collapse-item">
                            <div class="module-title">
                                <b>{{ theModule.nome_modulo }}</b>
                                <p>{{ theModule.descricao_do_modulo }}</p>
                            </div>
                            <button class="ml-auto" />
                        </div>
                        <b-collapse
                            :id="`collapse-${idx}`"
                            :visible="search.trim() !== '' || checkIsCurrentModule(theModule)">
                            <div
                                v-for="(item, id) in theModule.conteudo_do_modulo"
                                :key="id"
                                class="module-content-item"
                                @click="handleLessonClick(item)">
                                <span
                                    v-if="item.tipo_de_conteudo == 'Quiz'"
                                    class="icon-edit" />
                                <span class="mr-auto">{{
                                    item.tipo_de_conteudo == "Quiz" ? "Quiz" : item.nome_da_aula
                                }}</span>
                                <span
                                    v-if="item.tipo_de_conteudo == 'Quiz'"
                                    class="quiz-info">
                                    <small>{{ item.questoes.length }} Questões</small>
                                    <small v-if="item.tempo_estimado">{{
                                        item.tempo_estimado | estimatedTime
                                    }}</small>
                                </span>
                                <span
                                    v-if="checkCompleted(item)"
                                    class="icon-check-circled" />
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </b-collapse>
        </b-navbar>
    </b-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSidebar",
  filters: {
    estimatedTime(time) {
      return `${String(time ?? "0").padStart(2, "0")}min`;
    },
  },
  data: () => ({
    search: "",
    visibility: true,
  }),
  computed: {
    ...mapGetters([
      "getModules",
      "getCurrentModule",
      "getCourseValidity",
      "getProgressByContentId",
    ]),
    isValidity() {
      return this.getCourseValidity;
    },
    filteredModules() {
      const normalizedSearch = this.search.trim().toLowerCase();

      if (!normalizedSearch) {
        return this.getModules;
      }
      return this.getModules.filter(
        (module) => module.nome_modulo
          .toLowerCase()
          .includes(normalizedSearch)
          || module?.descricao_do_modulo
            ?.toLowerCase()
            .includes(normalizedSearch)
          || module.conteudo_do_modulo.some(
            ({ nome_da_aula: nomeDaAula, descricao_da_aula: descricaoDaAula }) => nomeDaAula
              ?.toLowerCase().includes(normalizedSearch)
              || descricaoDaAula
                ?.toLowerCase()
                .includes(normalizedSearch),
          ),
      );
    },
  },
  methods: {
    ...mapActions([
      "selectLesson",
    ]),
    async handleLessonClick(lesson) {
      await this.selectLesson(lesson);
      this.closeMobileMenu();
    },
    closeMobileMenu() {
      const element = document.querySelector(".navbar-toggler");
      const isMobile = window.innerWidth < 768;

      if (isMobile && element) {
        element.click();
      }
    },
    checkIsCurrentModule(item) {
      return (
        item.nome_modulo && item.nome_modulo === this.getCurrentModule.title
      );
    },
    checkCompleted(lesson) {
      return Boolean(this.getProgressByContentId(lesson.content_id)?.completed);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables";

.sidebar {
  height: calc(100vh - 70px);
  box-shadow: 2px 4px 8px rgba(0, 18, 63, 0.08);
  z-index: 2;

  .box-time-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    gap: 4px;
    height: 94px;
    left: 16px;
    top: 148px;
    margin: 0 20px;
    background: #F3F6FF;
    border: 1px solid #3366FF;
    border-radius: 4px;

    .header-time-left {
      display: inline;
      width: 100%;
    }

    .title-time-left,
    .close-time-left,
    .time-left {
      font-style: normal;
      font-size: 14px;
      color: #2952CC;
    }

    .title-time-left {
      font-weight: 600;
      line-height: 0px;
      margin-top: 5px;
      float: left;
      width: 90%;
    }

    .close-time-left {
      font-weight: 400;
      text-align: right;
      display: inline;
      float: right;
      width: 10%;
      margin-top: -6px;
      cursor: pointer;
      background: none;
      border: none;
    }

    .time-left {
      font-weight: 400;
      line-height: 20px;
      margin-top: -3px;
    }
  }

  .sidebar-nav-menu {
    display: flex;
    width: 100%;
    align-items: center;

    .search {
      box-sizing: border-box;
      border: 1px solid $grey-02;
      border-radius: 4px;
      width: 100%;
      display: flex;
      height: 38px;
      line-height: 38px;
      padding: 0 16px;
      margin: 24px 16px;

      input {
        width: 100%;
        border: none;
        outline: none;
      }

      &:after {
        font-family: "icomoon";
        content: "\e90b";
        font-size: 18px;
      }
    }

    .navbar-toggler {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;

      .btn-bar {
        border-top: 6px solid $primary-dark;
        border-bottom: 6px solid $primary-dark;
        padding: 4px 12px;
        font-size: 4px;
        line-height: 4px;
      }
    }
  }

  .modules-area {
    overflow-y: auto;
    height: calc(100vh - 172px);
    width: 100%;

    .certificate-steps {
      padding: 0 16px 16px;
    }

    .show-certificate {
      border: 1px solid $grey-02;
      border-radius: 4px;
      background: $white;
      padding: 16px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      span {
        color: $text-dark;
        font-size: 14px;
        line-height: 17px;
        font-weight: 600;
      }

    }
  }

  [id^="collapse-"] {
    border-radius: 0 0 4px 4px;
    overflow: hidden;

    .module-content-item {
      background: $grey-01;
      display: flex;
      align-items: center;
      padding: 24px 16px;
      margin-bottom: 2px;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: $text-dark;
      text-overflow: ellipsis;
      cursor: pointer;

      .icon-edit {
        font-size: 24px;
        margin-right: 4px;
      }

      .icon-check-circled {
        color: $success;
        font-size: 24px;
      }

      .quiz-info {
        small {
          font-size: 12px;
          line-height: 15px;
          color: $grey-03;
          margin-right: 16px;
        }
      }

      &:last-child {
        border-radius: 0 0 4px 4px;
        margin-bottom: 0;
      }
    }
  }

  .collapse-item {
    display: flex;
    align-items: center;
    background: $white;
    box-shadow: 0 2px 4px rgba(0, 18, 63, 0.08);
    border-radius: 4px;
    padding: 18px;

    &:hover {
      background: $grey-01;
    }

    &.not-collapsed {
      background: $grey-01;
      border-radius: 4px 4px 0 0;

      button {
        &::before {
          font-family: "icomoon";
          content: "\e909";
        }
      }
    }

    .module-title {
      padding-right: 16px;

      b {
        font-family: "Helvetica", sans-serif;
        font-weight: 600;
        font-size: 18px;
        line-height: 1.4;
        color: $text-dark;
      }

      p {
        font-size: 14px;
        line-height: 17px;
        color: $text-dark;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: all 0.3s ease-in;
      }
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 24px;
      width: 24px;
      border: none;
      background: transparent;
      font-size: 24px;
      color: $primary-dark;

      &::before {
        font-family: "icomoon";
        content: "\e90a";
        font-size: 24px;
      }
    }
  }
}

@media (max-width: 766px) {
  .sidebar {
    height: unset;
    box-shadow: none;
    border-bottom: 1px solid $grey-01;

    .sidebar-nav-menu {
      .search {
        width: calc(100% - 90px);
      }
    }

    .modules-area {
      overflow-y: unset;
      height: unset;
    }
  }
}
</style>
